export const FULLWIDTH_ROUTES: RegExp[] = [
  /^\/landing$/,
  /^\/storefront\//,
  /^\/auth$/,
  /^\/whiteboard\/public\//,
];

export const isFullwidthPath = (pathname: string) =>
  FULLWIDTH_ROUTES.some((re) => re.test(pathname));
